module.exports = __webpack_public_path__ + "static/media/silence_zone.54fa70db.jpg";